/**
 * Spanish profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: Spanish
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 221
 */

export const ES = {
  "metadata": {
    "name": "Spanish",
    "code": "es",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 221
  },
  "words": [
    {
      "word": "mierda",
      "severity": 2,
      "categories": [
        "general",
        "scatological"
      ],
      "variations": [
        "mierd@",
        "m1erda",
        "mrd"
      ],
      "case_sensitive": false,
      "context_notes": "Universal Spanish profanity, equivalent to 'shit' in English",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "joder",
      "severity": 2,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "jod3r",
        "j0der",
        "jodr"
      ],
      "case_sensitive": false,
      "context_notes": "Very common in Spain, less offensive than English 'fuck'",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "coño",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "c0ño",
        "coñ0",
        "con0"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for female genitalia, very offensive, especially in Latin America",
      "target_type": "general",
      "regions": [
        "spain",
        "venezuela",
        "colombia"
      ],
      "gender_variations": null
    },
    {
      "word": "puta",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "put@",
        "p*ta",
        "pta"
      ],
      "case_sensitive": false,
      "context_notes": "Highly offensive, targets women specifically",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "puto",
        "feminine": "puta"
      }
    },
    {
      "word": "puto",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "put0",
        "p*to",
        "pto"
      ],
      "case_sensitive": false,
      "context_notes": "Masculine form, can be homophobic slur, severity varies by region",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "puto",
        "feminine": "puta"
      }
    },
    {
      "word": "cabrón",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "cabr0n",
        "cabron",
        "cbron"
      ],
      "case_sensitive": false,
      "context_notes": "Ranges from mild to offensive depending on region, can mean 'bastard' or be friendly",
      "target_type": "individual",
      "regions": [
        "mexico",
        "spain"
      ],
      "gender_variations": {
        "masculine": "cabrón",
        "feminine": "cabrona"
      }
    },
    {
      "word": "pendejo",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "p3ndejo",
        "pendej0",
        "pndejo"
      ],
      "case_sensitive": false,
      "context_notes": "Common Mexican insult meaning 'idiot' or 'asshole'",
      "target_type": "individual",
      "regions": [
        "mexico",
        "colombia",
        "venezuela"
      ],
      "gender_variations": {
        "masculine": "pendejo",
        "feminine": "pendeja"
      }
    },
    {
      "word": "culero",
      "severity": 2,
      "categories": [
        "general",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "cul3ro",
        "culer0"
      ],
      "case_sensitive": false,
      "context_notes": "Mexican slang, can be homophobic, means 'asshole' literally and figuratively",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": {
        "masculine": "culero",
        "feminine": "culera"
      }
    },
    {
      "word": "hijo de puta",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "hijo d puta",
        "hdp",
        "hijodeputa"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a whore, very offensive compound insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "hijo de puta",
        "feminine": "hija de puta"
      }
    },
    {
      "word": "maricón",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "maric0n",
        "maricon",
        "mrcn"
      ],
      "case_sensitive": false,
      "context_notes": "Homophobic slur, extremely offensive to LGBTQ+ community",
      "target_type": "individual",
      "regions": [
        "spain",
        "argentina"
      ],
      "gender_variations": {
        "masculine": "maricón",
        "feminine": "maricona"
      }
    },
    {
      "word": "bolludo",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "b0ludo",
        "bolud0"
      ],
      "case_sensitive": false,
      "context_notes": "Argentine slang, can be friendly or insulting depending on context",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": {
        "masculine": "boludo",
        "feminine": "boluda"
      }
    },
    {
      "word": "chingar",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "ch1ngar",
        "chingr"
      ],
      "case_sensitive": false,
      "context_notes": "Mexican verb with multiple meanings, from mild to very offensive",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "verga",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "v3rga",
        "verg@"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for penis, very common in Mexico and Central America",
      "target_type": "general",
      "regions": [
        "mexico",
        "colombia",
        "venezuela"
      ],
      "gender_variations": null
    },
    {
      "word": "carajo",
      "severity": 2,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "car@jo",
        "caraj0"
      ],
      "case_sensitive": false,
      "context_notes": "Common expletive, less offensive than English equivalents",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "mamón",
      "severity": 2,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "mam0n",
        "mamn"
      ],
      "case_sensitive": false,
      "context_notes": "Calling someone annoying or a 'sucker', sexual undertones",
      "target_type": "individual",
      "regions": [
        "mexico",
        "spain"
      ],
      "gender_variations": {
        "masculine": "mamón",
        "feminine": "mamona"
      }
    },
    {
      "word": "gilipollas",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "gilip0llas",
        "gilipollas"
      ],
      "case_sensitive": false,
      "context_notes": "Spanish insult meaning 'idiot' or 'jerk'",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "capullo",
      "severity": 1,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "cap*llo",
        "capull0"
      ],
      "case_sensitive": false,
      "context_notes": "Spanish mild insult, literally 'cocoon' but slang for penis tip",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "joto",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "j0to",
        "jot0"
      ],
      "case_sensitive": false,
      "context_notes": "Mexican homophobic slur, extremely offensive",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "tortillera",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "lgbtq"
      ],
      "variations": [
        "tortiller@",
        "tortillr@"
      ],
      "case_sensitive": false,
      "context_notes": "Lesbian slur in Spanish, very offensive",
      "target_type": "individual",
      "regions": [
        "spain",
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "sudaca",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs",
        "ethnic"
      ],
      "variations": [
        "sud@ca",
        "sudac@"
      ],
      "case_sensitive": false,
      "context_notes": "Ethnic slur used in Spain against South Americans, very offensive",
      "target_type": "group",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "negro",
      "severity": 3,
      "categories": [
        "racial",
        "slurs"
      ],
      "variations": [
        "n3gro",
        "negr0"
      ],
      "case_sensitive": false,
      "context_notes": "Context-dependent, can be neutral or offensive, varies greatly by region",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "negro",
        "feminine": "negra"
      }
    },
    {
      "word": "polaco",
      "severity": 3,
      "categories": [
        "ethnic",
        "slurs"
      ],
      "variations": [
        "pol@co",
        "polac0"
      ],
      "case_sensitive": false,
      "context_notes": "Used as insult in Argentina, originally meaning 'Polish' but used against any immigrant",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": {
        "masculine": "polaco",
        "feminine": "polaca"
      }
    },
    {
      "word": "huevón",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "huev0n",
        "weon",
        "weón"
      ],
      "case_sensitive": false,
      "context_notes": "Chilean/Peruvian slang, can be friendly or insulting, very common",
      "target_type": "individual",
      "regions": [
        "chile",
        "peru"
      ],
      "gender_variations": {
        "masculine": "huevón",
        "feminine": "huevona"
      }
    },
    {
      "word": "gonorrea",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "gonorr3a",
        "gnrrea"
      ],
      "case_sensitive": false,
      "context_notes": "Colombian insult using STD name, moderately offensive",
      "target_type": "individual",
      "regions": [
        "colombia"
      ],
      "gender_variations": null
    },
    {
      "word": "mamagallismo",
      "severity": 2,
      "categories": [
        "general",
        "sexual"
      ],
      "variations": [
        "mamagallism0",
        "mamgallismo"
      ],
      "case_sensitive": false,
      "context_notes": "Colombian vulgar term, sexual undertones",
      "target_type": "general",
      "regions": [
        "colombia"
      ],
      "gender_variations": null
    },
    {
      "word": "anda a cagar",
      "severity": 2,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "anda a cagr",
        "anda cagar"
      ],
      "case_sensitive": false,
      "context_notes": "Go shit yourself, common dismissive phrase",
      "target_type": "individual",
      "regions": [
        "argentina",
        "uruguay"
      ],
      "gender_variations": null
    },
    {
      "word": "anda a la mierda",
      "severity": 2,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "anda la mierda",
        "anda a la mierd@"
      ],
      "case_sensitive": false,
      "context_notes": "Go to shit, dismissive phrase",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "arrastrado",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "arrastr@do",
        "arrastrad0"
      ],
      "case_sensitive": false,
      "context_notes": "Scumbag, lowlife",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "arrastrado",
        "feminine": "arrastrada"
      }
    },
    {
      "word": "asesinato",
      "severity": 3,
      "categories": [
        "violence"
      ],
      "variations": [
        "ases1nato",
        "asesin@to"
      ],
      "case_sensitive": false,
      "context_notes": "Murder, violent term",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "asno",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "@sno",
        "asn0"
      ],
      "case_sensitive": false,
      "context_notes": "Jackass, donkey, mild insult",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "baboso",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "bab0so",
        "babos0"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot, slimeball",
      "target_type": "individual",
      "regions": [
        "mexico",
        "colombia"
      ],
      "gender_variations": {
        "masculine": "baboso",
        "feminine": "babosa"
      }
    },
    {
      "word": "bastardo",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "bast@rdo",
        "bastard0"
      ],
      "case_sensitive": false,
      "context_notes": "Bastard",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "bastardo",
        "feminine": "bastarda"
      }
    },
    {
      "word": "bicho",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "b1cho",
        "bich0"
      ],
      "case_sensitive": false,
      "context_notes": "Dick in Puerto Rico, bug elsewhere",
      "target_type": "general",
      "regions": [
        "puerto_rico"
      ],
      "gender_variations": null
    },
    {
      "word": "bollera",
      "severity": 4,
      "categories": [
        "hate_speech",
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "b0llera",
        "boller@"
      ],
      "case_sensitive": false,
      "context_notes": "Lesbian slur in Spain, very offensive",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "boludo",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "b0ludo",
        "bolud0"
      ],
      "case_sensitive": false,
      "context_notes": "Argentine slang, can be friendly or insulting",
      "target_type": "individual",
      "regions": [
        "argentina",
        "uruguay"
      ],
      "gender_variations": {
        "masculine": "boludo",
        "feminine": "boluda"
      }
    },
    {
      "word": "bruja",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "bruj@",
        "bruj4"
      ],
      "case_sensitive": false,
      "context_notes": "Witch, bitch",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "cabrona",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "cabr0na",
        "cabrn@"
      ],
      "case_sensitive": false,
      "context_notes": "Feminine form of cabrón",
      "target_type": "individual",
      "regions": [
        "mexico",
        "spain"
      ],
      "gender_variations": {
        "masculine": "cabrón",
        "feminine": "cabrona"
      }
    },
    {
      "word": "caca",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "c@ca",
        "cac@"
      ],
      "case_sensitive": false,
      "context_notes": "Shit, mild childish term",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "cachón",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "cach0n",
        "cach@n"
      ],
      "case_sensitive": false,
      "context_notes": "Cuckold",
      "target_type": "individual",
      "regions": [
        "spain",
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "chingada",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "ch1ngada",
        "chingad@"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked, Mexican profanity",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "chingados",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "ch1ngados",
        "chingad0s"
      ],
      "case_sensitive": false,
      "context_notes": "What the fuck, Mexican expression",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "chingón",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "ch1ngon",
        "ching0n"
      ],
      "case_sensitive": false,
      "context_notes": "Badass in Mexico, can be positive or negative",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": {
        "masculine": "chingón",
        "feminine": "chingona"
      }
    },
    {
      "word": "chupada",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "chupad@",
        "chupad4"
      ],
      "case_sensitive": false,
      "context_notes": "Blowjob",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "chupapollas",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "chupap0llas",
        "chupa pollas"
      ],
      "case_sensitive": false,
      "context_notes": "Cocksucker, very vulgar",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "chupetón",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [
        "chupet0n",
        "chupetn"
      ],
      "case_sensitive": false,
      "context_notes": "Hickey, love bite",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "cojones",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "c0jones",
        "cojns"
      ],
      "case_sensitive": false,
      "context_notes": "Balls, testicles, context-dependent severity",
      "target_type": "general",
      "regions": [
        "spain",
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "coger",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "c0ger",
        "cogr"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck in Latin America, to take in Spain",
      "target_type": "general",
      "regions": [
        "latin_america"
      ],
      "gender_variations": null
    },
    {
      "word": "concha",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "c0ncha",
        "conch@"
      ],
      "case_sensitive": false,
      "context_notes": "Cunt, very offensive",
      "target_type": "general",
      "regions": [
        "argentina",
        "uruguay",
        "chile"
      ],
      "gender_variations": null
    },
    {
      "word": "concha de tu madre",
      "severity": 4,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "concha d tu madre",
        "concha tu madre"
      ],
      "case_sensitive": false,
      "context_notes": "Your mother's cunt, extreme insult",
      "target_type": "individual",
      "regions": [
        "argentina",
        "uruguay"
      ],
      "gender_variations": null
    },
    {
      "word": "coprofagía",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "coprofagi@",
        "coprofagia"
      ],
      "case_sensitive": false,
      "context_notes": "Coprophagia, eating feces",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "culera",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "cul3ra",
        "culer@"
      ],
      "case_sensitive": false,
      "context_notes": "Feminine form of culero",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": {
        "masculine": "culero",
        "feminine": "culera"
      }
    },
    {
      "word": "culiado",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "culi@do",
        "culiad0"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked in Chile/Argentina",
      "target_type": "individual",
      "regions": [
        "chile",
        "argentina"
      ],
      "gender_variations": {
        "masculine": "culiado",
        "feminine": "culiada"
      }
    },
    {
      "word": "culo",
      "severity": 2,
      "categories": [
        "body_parts"
      ],
      "variations": [
        "cul0",
        "cul@"
      ],
      "case_sensitive": false,
      "context_notes": "Ass, butt",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "desgraciado",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "desgraci@do",
        "desgraciad0"
      ],
      "case_sensitive": false,
      "context_notes": "Wretch, scumbag",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "desgraciado",
        "feminine": "desgraciada"
      }
    },
    {
      "word": "drogas",
      "severity": 2,
      "categories": [
        "drugs"
      ],
      "variations": [
        "dr0gas",
        "drog@s"
      ],
      "case_sensitive": false,
      "context_notes": "Drugs",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "esperma",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "esperm@",
        "esp3rma"
      ],
      "case_sensitive": false,
      "context_notes": "Sperm, semen",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "estúpido",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "estupid0",
        "estupid@"
      ],
      "case_sensitive": false,
      "context_notes": "Stupid",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "estúpido",
        "feminine": "estúpida"
      }
    },
    {
      "word": "follar",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "f0llar",
        "follr"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck in Spain",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "follador",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "f0llador",
        "follad0r"
      ],
      "case_sensitive": false,
      "context_notes": "Fucker in Spain",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": {
        "masculine": "follador",
        "feminine": "folladora"
      }
    },
    {
      "word": "guarra",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "gu@rra",
        "guarr@"
      ],
      "case_sensitive": false,
      "context_notes": "Slut, pig in Spain",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": {
        "masculine": "guarro",
        "feminine": "guarra"
      }
    },
    {
      "word": "hija de puta",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "hija d puta",
        "hijadeputa"
      ],
      "case_sensitive": false,
      "context_notes": "Daughter of a whore",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "hijo de puta",
        "feminine": "hija de puta"
      }
    },
    {
      "word": "hijaputa",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "hij@puta",
        "hijaput@"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a bitch, combined form",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "hijueputa",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "hijuput@",
        "hp",
        "hjp"
      ],
      "case_sensitive": false,
      "context_notes": "SOB in Colombia, very common",
      "target_type": "individual",
      "regions": [
        "colombia"
      ],
      "gender_variations": null
    },
    {
      "word": "hostia",
      "severity": 2,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "h0stia",
        "hosti@"
      ],
      "case_sensitive": false,
      "context_notes": "Holy shit in Spain, religious profanity",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "hueco",
      "severity": 3,
      "categories": [
        "hate_speech",
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "huec0",
        "hu3co"
      ],
      "case_sensitive": false,
      "context_notes": "Gay, derogatory term",
      "target_type": "individual",
      "regions": [
        "colombia",
        "venezuela"
      ],
      "gender_variations": null
    },
    {
      "word": "huevona",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "huev0na",
        "huevon@"
      ],
      "case_sensitive": false,
      "context_notes": "Dumbass, feminine form",
      "target_type": "individual",
      "regions": [
        "chile",
        "peru"
      ],
      "gender_variations": {
        "masculine": "huevón",
        "feminine": "huevona"
      }
    },
    {
      "word": "huevos",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "huev0s",
        "huevs"
      ],
      "case_sensitive": false,
      "context_notes": "Balls, testicles",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "imbécil",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "imbecil",
        "imb3cil"
      ],
      "case_sensitive": false,
      "context_notes": "Imbecile",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "idiota",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "idi0ta",
        "idiot@"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "jeta",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "j3ta",
        "jet@"
      ],
      "case_sensitive": false,
      "context_notes": "Nerve, gall, cheek",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "jodido",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "j0dido",
        "jodid0"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked, fucked up",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "jodido",
        "feminine": "jodida"
      }
    },
    {
      "word": "la concha de tu madre",
      "severity": 4,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "la concha d tu madre",
        "concha de tu madre"
      ],
      "case_sensitive": false,
      "context_notes": "Your mother's cunt, Argentina extreme insult",
      "target_type": "individual",
      "regions": [
        "argentina",
        "uruguay"
      ],
      "gender_variations": null
    },
    {
      "word": "la puta",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "la put@",
        "la pta"
      ],
      "case_sensitive": false,
      "context_notes": "The whore",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "la puta madre",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "la put@ madre",
        "la puta mdr"
      ],
      "case_sensitive": false,
      "context_notes": "The whore mother, strong insult",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "lambón",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "lamb0n",
        "lambn"
      ],
      "case_sensitive": false,
      "context_notes": "Ass-kisser, brown-noser",
      "target_type": "individual",
      "regions": [
        "mexico",
        "colombia"
      ],
      "gender_variations": null
    },
    {
      "word": "mamagüevo",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "mamaguevo",
        "mamagüev0"
      ],
      "case_sensitive": false,
      "context_notes": "Cocksucker in Caribbean, very vulgar",
      "target_type": "individual",
      "regions": [
        "venezuela",
        "caribbean"
      ],
      "gender_variations": null
    },
    {
      "word": "mamar",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "m@mar",
        "mamr"
      ],
      "case_sensitive": false,
      "context_notes": "To suck, sexual undertones",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "mamarracho",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "mamarr@cho",
        "mamarach0"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot, mess, ridiculous person",
      "target_type": "individual",
      "regions": [
        "spain",
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "mamona",
      "severity": 2,
      "categories": [
        "general",
        "sexual",
        "slurs"
      ],
      "variations": [
        "mam0na",
        "mamon@"
      ],
      "case_sensitive": false,
      "context_notes": "Feminine form of mamón",
      "target_type": "individual",
      "regions": [
        "mexico",
        "spain"
      ],
      "gender_variations": {
        "masculine": "mamón",
        "feminine": "mamona"
      }
    },
    {
      "word": "malparido",
      "severity": 3,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "malp@rido",
        "malparid0"
      ],
      "case_sensitive": false,
      "context_notes": "Bastard, evil person in Colombia",
      "target_type": "individual",
      "regions": [
        "colombia"
      ],
      "gender_variations": {
        "masculine": "malparido",
        "feminine": "malparida"
      }
    },
    {
      "word": "manflor",
      "severity": 4,
      "categories": [
        "hate_speech",
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "manfl0r",
        "manflr"
      ],
      "case_sensitive": false,
      "context_notes": "Lesbian slur in Mexico",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "maraca",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "mar@ca",
        "marac@"
      ],
      "case_sensitive": false,
      "context_notes": "Whore in Venezuela",
      "target_type": "individual",
      "regions": [
        "venezuela"
      ],
      "gender_variations": null
    },
    {
      "word": "marica",
      "severity": 3,
      "categories": [
        "hate_speech",
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "mar1ca",
        "maric@"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot, can be friendly in Colombia but still offensive",
      "target_type": "individual",
      "regions": [
        "colombia",
        "venezuela"
      ],
      "gender_variations": null
    },
    {
      "word": "maricona",
      "severity": 4,
      "categories": [
        "hate_speech",
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "maric0na",
        "maricon@"
      ],
      "case_sensitive": false,
      "context_notes": "Feminine form of maricón",
      "target_type": "individual",
      "regions": [
        "spain",
        "argentina"
      ],
      "gender_variations": {
        "masculine": "maricón",
        "feminine": "maricona"
      }
    },
    {
      "word": "mariquita",
      "severity": 3,
      "categories": [
        "hate_speech",
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "mariqu1ta",
        "mariquit@"
      ],
      "case_sensitive": false,
      "context_notes": "Sissy, faggot, diminutive form",
      "target_type": "individual",
      "regions": [
        "spain",
        "latin_america"
      ],
      "gender_variations": null
    },
    {
      "word": "mierdero",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "mierder0",
        "mierd3ro"
      ],
      "case_sensitive": false,
      "context_notes": "Shithole",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "mierdicola",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "mierdic0la",
        "mierdikola"
      ],
      "case_sensitive": false,
      "context_notes": "Little shit, diminutive",
      "target_type": "individual",
      "regions": [
        "chile"
      ],
      "gender_variations": null
    },
    {
      "word": "mierdo",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "mierd0",
        "m1erdo"
      ],
      "case_sensitive": false,
      "context_notes": "Shithouse",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "minga",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "m1nga",
        "ming@"
      ],
      "case_sensitive": false,
      "context_notes": "Dick in Peru",
      "target_type": "general",
      "regions": [
        "peru"
      ],
      "gender_variations": null
    },
    {
      "word": "mogólico",
      "severity": 4,
      "categories": [
        "hate_speech",
        "ableist",
        "slurs"
      ],
      "variations": [
        "mogolic0",
        "mogolic@"
      ],
      "case_sensitive": false,
      "context_notes": "Retard, ableist slur, very offensive",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "mogólico",
        "feminine": "mogólica"
      }
    },
    {
      "word": "mongolito",
      "severity": 4,
      "categories": [
        "hate_speech",
        "ableist",
        "slurs"
      ],
      "variations": [
        "mongol1to",
        "mongolit@"
      ],
      "case_sensitive": false,
      "context_notes": "Retard, ableist slur, very offensive",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "mongolito",
        "feminine": "mongolita"
      }
    },
    {
      "word": "negra",
      "severity": 3,
      "categories": [
        "racial",
        "slurs"
      ],
      "variations": [
        "n3gra",
        "negr@"
      ],
      "case_sensitive": false,
      "context_notes": "Context-dependent, feminine form",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "negro",
        "feminine": "negra"
      }
    },
    {
      "word": "panocha",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "pan0cha",
        "panoch@"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy, vulgar",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "papaya",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "pap@ya",
        "papay@"
      ],
      "case_sensitive": false,
      "context_notes": "Pussy in Cuba, fruit elsewhere",
      "target_type": "general",
      "regions": [
        "cuba"
      ],
      "gender_variations": null
    },
    {
      "word": "pelotudo",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "pel0tudo",
        "pelotud0"
      ],
      "case_sensitive": false,
      "context_notes": "Asshole, idiot in Argentina",
      "target_type": "individual",
      "regions": [
        "argentina",
        "uruguay"
      ],
      "gender_variations": {
        "masculine": "pelotudo",
        "feminine": "pelotuda"
      }
    },
    {
      "word": "pendeja",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "p3ndeja",
        "pendej@"
      ],
      "case_sensitive": false,
      "context_notes": "Feminine form of pendejo",
      "target_type": "individual",
      "regions": [
        "mexico",
        "colombia",
        "venezuela"
      ],
      "gender_variations": {
        "masculine": "pendejo",
        "feminine": "pendeja"
      }
    },
    {
      "word": "pene",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "p3ne",
        "pen3"
      ],
      "case_sensitive": false,
      "context_notes": "Penis, clinical term",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "perro",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "p3rro",
        "perr0"
      ],
      "case_sensitive": false,
      "context_notes": "Dog, bastard",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "perro",
        "feminine": "perra"
      }
    },
    {
      "word": "pinche",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "p1nche",
        "pinch3"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking, intensifier in Mexico",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "pinga",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "p1nga",
        "ping@"
      ],
      "case_sensitive": false,
      "context_notes": "Dick in Cuba",
      "target_type": "general",
      "regions": [
        "cuba",
        "caribbean"
      ],
      "gender_variations": null
    },
    {
      "word": "pipi",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [
        "p1pi",
        "pipi"
      ],
      "case_sensitive": false,
      "context_notes": "Pee, childish term",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "piruja",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "p1ruja",
        "piruj@"
      ],
      "case_sensitive": false,
      "context_notes": "Prostitute in Mexico",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "polaca",
      "severity": 3,
      "categories": [
        "ethnic",
        "slurs"
      ],
      "variations": [
        "pol@ca",
        "polac@"
      ],
      "case_sensitive": false,
      "context_notes": "Feminine form, ethnic slur in Argentina",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": {
        "masculine": "polaco",
        "feminine": "polaca"
      }
    },
    {
      "word": "polla",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "p0lla",
        "poll@"
      ],
      "case_sensitive": false,
      "context_notes": "Dick in Spain",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "prostituta",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "pr0stituta",
        "prostitut@"
      ],
      "case_sensitive": false,
      "context_notes": "Prostitute, whore",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "puñal",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "puñ@l",
        "punal"
      ],
      "case_sensitive": false,
      "context_notes": "Dagger, backstabber",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "puñeta",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "puñet@",
        "puneta"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck, damn in Puerto Rico",
      "target_type": "general",
      "regions": [
        "puerto_rico"
      ],
      "gender_variations": null
    },
    {
      "word": "puñetero",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "puñeter0",
        "puneter0"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking, annoying",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": {
        "masculine": "puñetero",
        "feminine": "puñetera"
      }
    },
    {
      "word": "putazo",
      "severity": 2,
      "categories": [
        "violence"
      ],
      "variations": [
        "put@zo",
        "putaz0"
      ],
      "case_sensitive": false,
      "context_notes": "Punch, blow",
      "target_type": "general",
      "regions": [
        "mexico",
        "latin_america"
      ],
      "gender_variations": null
    },
    {
      "word": "putón",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "put0n",
        "putn"
      ],
      "case_sensitive": false,
      "context_notes": "Big whore, augmentative",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "qué cabrón",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "que cabron",
        "q cabron"
      ],
      "case_sensitive": false,
      "context_notes": "What an asshole",
      "target_type": "individual",
      "regions": [
        "mexico",
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "rata",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "r@ta",
        "rat4"
      ],
      "case_sensitive": false,
      "context_notes": "Rat, thief",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "rosquete",
      "severity": 2,
      "categories": [
        "body_parts"
      ],
      "variations": [
        "rosquet3",
        "rosquet@"
      ],
      "case_sensitive": false,
      "context_notes": "Asshole in Argentina",
      "target_type": "general",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "sexo",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [
        "s3xo",
        "sex0"
      ],
      "case_sensitive": false,
      "context_notes": "Sex, neutral term",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "sidoso",
      "severity": 4,
      "categories": [
        "hate_speech",
        "slurs"
      ],
      "variations": [
        "sid0so",
        "sidoso"
      ],
      "case_sensitive": false,
      "context_notes": "AIDS victim, extremely offensive",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "sidoso",
        "feminine": "sidosa"
      }
    },
    {
      "word": "soplagaitas",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "soplag@itas",
        "soplagaits"
      ],
      "case_sensitive": false,
      "context_notes": "Blowhard in Spain",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "tarado",
      "severity": 2,
      "categories": [
        "general",
        "slurs",
        "ableist"
      ],
      "variations": [
        "tar@do",
        "tarad0"
      ],
      "case_sensitive": false,
      "context_notes": "Retard, idiot, mildly ableist",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "tarado",
        "feminine": "tarada"
      }
    },
    {
      "word": "teta",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "t3ta",
        "tet@"
      ],
      "case_sensitive": false,
      "context_notes": "Tit, breast",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "tetas",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "t3tas",
        "tets"
      ],
      "case_sensitive": false,
      "context_notes": "Tits, breasts",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "tirar",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "t1rar",
        "tirr"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck in Argentina",
      "target_type": "general",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "tonto del culo",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "tonto dl culo",
        "tonto del cul0"
      ],
      "case_sensitive": false,
      "context_notes": "Dumbass in Spain",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "traga",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "tr@ga",
        "trag4"
      ],
      "case_sensitive": false,
      "context_notes": "Swallower, sexual undertones",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "tragaleche",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "tragalech3",
        "traga leche"
      ],
      "case_sensitive": false,
      "context_notes": "Cum swallower, very vulgar",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "vaca",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "v@ca",
        "vac4"
      ],
      "case_sensitive": false,
      "context_notes": "Cow, bitch",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "vete a la mierda",
      "severity": 2,
      "categories": [
        "scatological",
        "general"
      ],
      "variations": [
        "vete a la mierd@",
        "vete la mierda"
      ],
      "case_sensitive": false,
      "context_notes": "Go to hell, go to shit",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "vete al carajo",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "vete al car@jo",
        "vete carajo"
      ],
      "case_sensitive": false,
      "context_notes": "Go to hell",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "vete al diablo",
      "severity": 1,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "vete al di@blo",
        "vete diablo"
      ],
      "case_sensitive": false,
      "context_notes": "Go to the devil",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "vulva",
      "severity": 1,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "vulv@",
        "vulv4"
      ],
      "case_sensitive": false,
      "context_notes": "Vulva, clinical term",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "weón",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "weon",
        "weón",
        "we0n"
      ],
      "case_sensitive": false,
      "context_notes": "Dumbass in Chile, from huevón, can be friendly",
      "target_type": "individual",
      "regions": [
        "chile"
      ],
      "gender_variations": {
        "masculine": "weón",
        "feminine": "weona"
      }
    },
    {
      "word": "zorra",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "z0rra",
        "zorr@"
      ],
      "case_sensitive": false,
      "context_notes": "Slut, bitch, fox",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "zorro",
        "feminine": "zorra"
      }
    },
    {
      "word": "zorrón",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "z0rron",
        "zorron"
      ],
      "case_sensitive": false,
      "context_notes": "Big slut, augmentative",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": null
    },
    {
      "word": "gili",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "g1li",
        "gil1"
      ],
      "case_sensitive": false,
      "context_notes": "Short for gilipollas in Spain",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "gilipuertas",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "gilipuert@s",
        "gilipu3rtas"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot in Spain",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "hijoputa",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "hij0puta",
        "hijoput@"
      ],
      "case_sensitive": false,
      "context_notes": "Combined form of hijo de puta",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "joderse",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "j0derse",
        "jodrs"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck oneself, go fuck yourself",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "me cago en",
      "severity": 2,
      "categories": [
        "scatological",
        "religious"
      ],
      "variations": [
        "me cag0 en",
        "m cago en"
      ],
      "case_sensitive": false,
      "context_notes": "I shit on, Spanish blasphemy phrase",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "me cago en dios",
      "severity": 4,
      "categories": [
        "scatological",
        "religious",
        "hate_speech"
      ],
      "variations": [
        "me cag0 en dios",
        "m cago en dios"
      ],
      "case_sensitive": false,
      "context_notes": "I shit on God, extreme blasphemy",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "me cago en la leche",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "me cag0 en la leche",
        "m cago en la leche"
      ],
      "case_sensitive": false,
      "context_notes": "I shit on the milk, Spanish expression",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "me cago en los muertos",
      "severity": 3,
      "categories": [
        "scatological"
      ],
      "variations": [
        "me cag0 en los muertos",
        "m cago en los muertos"
      ],
      "case_sensitive": false,
      "context_notes": "I shit on the dead, very offensive",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "me cago en tu madre",
      "severity": 3,
      "categories": [
        "scatological",
        "slurs"
      ],
      "variations": [
        "me cag0 en tu madre",
        "m cago en tu madre"
      ],
      "case_sensitive": false,
      "context_notes": "I shit on your mother",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "me cago en tu puta madre",
      "severity": 4,
      "categories": [
        "scatological",
        "sexual",
        "slurs"
      ],
      "variations": [
        "me cag0 en tu puta madre",
        "m cago en tu puta madre"
      ],
      "case_sensitive": false,
      "context_notes": "I shit on your whore mother, extreme",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "me cago en todo",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "me cag0 en todo",
        "m cago en todo"
      ],
      "case_sensitive": false,
      "context_notes": "I shit on everything",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "ostia",
      "severity": 2,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "0stia",
        "osti@"
      ],
      "case_sensitive": false,
      "context_notes": "Holy shit in Spain, variant of hostia",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "polla en vinagre",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "p0lla en vinagre",
        "polla n vinagre"
      ],
      "case_sensitive": false,
      "context_notes": "Dick in vinegar, Spanish idiom",
      "target_type": "general",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "que te den",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "q te den",
        "que t den"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck you in Spain",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "que te folle un pez",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "q te folle un pez",
        "que t folle un pez"
      ],
      "case_sensitive": false,
      "context_notes": "May a fish fuck you, creative Spanish curse",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "que te jodan",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "q te jodan",
        "que t jodan"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck you, may they fuck you",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "tontolaba",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "tontol@ba",
        "tontol4ba"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot in Spain",
      "target_type": "individual",
      "regions": [
        "spain"
      ],
      "gender_variations": null
    },
    {
      "word": "a la chingada",
      "severity": 3,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "a la chingad@",
        "a la chingd"
      ],
      "case_sensitive": false,
      "context_notes": "To the fucked place, Mexican expression",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "chale",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "ch@le",
        "chal3"
      ],
      "case_sensitive": false,
      "context_notes": "Damn, mild expression in Mexico",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "chaqueta",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "chaquet@",
        "chaqu3ta"
      ],
      "case_sensitive": false,
      "context_notes": "Masturbation",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "chido",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "chid0",
        "ch1do"
      ],
      "case_sensitive": false,
      "context_notes": "Cool, can be used sarcastically",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "chinga tu madre",
      "severity": 4,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "chinga tu mdr",
        "chinga tu madr3"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck your mother, extreme Mexican insult",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "chingadera",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "chingader@",
        "chingadr"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking thing, Mexican slang",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "chingazo",
      "severity": 2,
      "categories": [
        "violence"
      ],
      "variations": [
        "chingaz0",
        "chingz"
      ],
      "case_sensitive": false,
      "context_notes": "Blow, punch in Mexico",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "estar hasta la madre",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "estar hsta la madre",
        "estar hasta la mdr"
      ],
      "case_sensitive": false,
      "context_notes": "Fed up, Mexican expression",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "güey",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "wey",
        "guey",
        "we"
      ],
      "case_sensitive": false,
      "context_notes": "Dude in Mexico, can be insulting",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "hijo de la chingada",
      "severity": 4,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "hijo d la chingada",
        "hijo de la chingd"
      ],
      "case_sensitive": false,
      "context_notes": "Son of the fucked one, Mexican extreme",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "hijo de su puta madre",
      "severity": 4,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "hijo d su puta madre",
        "hijo de su pta madre"
      ],
      "case_sensitive": false,
      "context_notes": "Son of his whore mother",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "malinchista",
      "severity": 2,
      "categories": [
        "ethnic",
        "slurs"
      ],
      "variations": [
        "malinchist@",
        "malinch1sta"
      ],
      "case_sensitive": false,
      "context_notes": "Traitor to Mexican culture",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "me vale madre",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "me vale mdr",
        "m vale madre"
      ],
      "case_sensitive": false,
      "context_notes": "I don't give a fuck, Mexican",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "no mames",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "no mms",
        "no mames"
      ],
      "case_sensitive": false,
      "context_notes": "No fucking way, Mexican slang",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "pinche güey",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "pinche wey",
        "pinch3 guey"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking dude, Mexican",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "pinche pendejo",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "pinche pndejo",
        "pinch3 pendejo"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking asshole, Mexican",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "puto pendejo",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "put0 pendejo",
        "puto pndejo"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking idiot, Mexican",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "vale verga",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "vale verg@",
        "val3 verga"
      ],
      "case_sensitive": false,
      "context_notes": "Worth dick, worthless in Mexico",
      "target_type": "general",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "vete a la chingada",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "vete a la chingd",
        "vet a la chingada"
      ],
      "case_sensitive": false,
      "context_notes": "Go to hell, Mexican version",
      "target_type": "individual",
      "regions": [
        "mexico"
      ],
      "gender_variations": null
    },
    {
      "word": "andá a cagar",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [
        "anda a cagar",
        "andá cagar"
      ],
      "case_sensitive": false,
      "context_notes": "Go shit, Argentine variant",
      "target_type": "individual",
      "regions": [
        "argentina",
        "uruguay"
      ],
      "gender_variations": null
    },
    {
      "word": "boludo de mierda",
      "severity": 2,
      "categories": [
        "general",
        "scatological",
        "slurs"
      ],
      "variations": [
        "boludo d mierda",
        "bolud0 de mierda"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking idiot, Argentine",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "boludez",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "bolud3z",
        "boludz"
      ],
      "case_sensitive": false,
      "context_notes": "Bullshit, stupidity in Argentina",
      "target_type": "general",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "che boludo",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "ch boludo",
        "che bolud0"
      ],
      "case_sensitive": false,
      "context_notes": "Hey dumbass, can be friendly",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "chupame la pija",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "chupame la pij@",
        "chupam la pija"
      ],
      "case_sensitive": false,
      "context_notes": "Suck my dick, Argentine",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "forro",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "f0rro",
        "forr0"
      ],
      "case_sensitive": false,
      "context_notes": "Condom, asshole in Argentina",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "gil",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "g1l",
        "gil"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot in Argentina",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "hincha pelotas",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "hincha pelots",
        "hincha pel0tas"
      ],
      "case_sensitive": false,
      "context_notes": "Ball breaker, annoying person",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "la concha bien de tu madre",
      "severity": 4,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "la concha bien d tu madre",
        "la concha bien de tu mdr"
      ],
      "case_sensitive": false,
      "context_notes": "Your mother's cunt, strong Argentine",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "la puta que te parió",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "la puta q te parió",
        "la pta que te parió"
      ],
      "case_sensitive": false,
      "context_notes": "The whore who birthed you",
      "target_type": "individual",
      "regions": [
        "argentina",
        "uruguay"
      ],
      "gender_variations": null
    },
    {
      "word": "pajero",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "pajer0",
        "paj3ro"
      ],
      "case_sensitive": false,
      "context_notes": "Wanker, jerk-off",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": {
        "masculine": "pajero",
        "feminine": "pajera"
      }
    },
    {
      "word": "pelado",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "pel@do",
        "pelad0"
      ],
      "case_sensitive": false,
      "context_notes": "Baldy, poor person, insulting",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "pelotudez",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "pelotud3z",
        "pelotudz"
      ],
      "case_sensitive": false,
      "context_notes": "Stupidity, Argentine slang",
      "target_type": "general",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "pija",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "p1ja",
        "pij@"
      ],
      "case_sensitive": false,
      "context_notes": "Dick in Argentina",
      "target_type": "general",
      "regions": [
        "argentina",
        "uruguay"
      ],
      "gender_variations": null
    },
    {
      "word": "quilombo",
      "severity": 2,
      "categories": [
        "general"
      ],
      "variations": [
        "quilomb0",
        "quilmbo"
      ],
      "case_sensitive": false,
      "context_notes": "Whorehouse, mess in Argentina",
      "target_type": "general",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "salame",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "sal@me",
        "salam3"
      ],
      "case_sensitive": false,
      "context_notes": "Salami, idiot in Argentina",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "sorete",
      "severity": 2,
      "categories": [
        "scatological",
        "slurs"
      ],
      "variations": [
        "soret3",
        "soret@"
      ],
      "case_sensitive": false,
      "context_notes": "Piece of shit, Argentine",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "trolo",
      "severity": 4,
      "categories": [
        "hate_speech",
        "lgbtq",
        "slurs"
      ],
      "variations": [
        "tr0lo",
        "trol0"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot in Argentina, very offensive",
      "target_type": "individual",
      "regions": [
        "argentina"
      ],
      "gender_variations": null
    },
    {
      "word": "berraco",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "berr@co",
        "berrac0"
      ],
      "case_sensitive": false,
      "context_notes": "Tough guy, asshole in Colombia",
      "target_type": "individual",
      "regions": [
        "colombia"
      ],
      "gender_variations": null
    },
    {
      "word": "chimba",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "ch1mba",
        "chimb@"
      ],
      "case_sensitive": false,
      "context_notes": "Cool or pussy, context-dependent in Colombia",
      "target_type": "general",
      "regions": [
        "colombia"
      ],
      "gender_variations": null
    },
    {
      "word": "güevón",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "guev0n",
        "guevn"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot in Venezuela",
      "target_type": "individual",
      "regions": [
        "venezuela"
      ],
      "gender_variations": null
    },
    {
      "word": "mamaguevismo",
      "severity": 2,
      "categories": [
        "sexual",
        "general"
      ],
      "variations": [
        "mamaguevism0",
        "mamaguevsmo"
      ],
      "case_sensitive": false,
      "context_notes": "Cocksucking behavior, Venezuelan",
      "target_type": "general",
      "regions": [
        "venezuela"
      ],
      "gender_variations": null
    },
    {
      "word": "mamagüevos",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "mamaguevos",
        "mamagüev0s"
      ],
      "case_sensitive": false,
      "context_notes": "Plural cocksucker, Venezuelan",
      "target_type": "individual",
      "regions": [
        "venezuela"
      ],
      "gender_variations": null
    },
    {
      "word": "malparida",
      "severity": 3,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "malp@rida",
        "malparid@"
      ],
      "case_sensitive": false,
      "context_notes": "Feminine form of malparido",
      "target_type": "individual",
      "regions": [
        "colombia"
      ],
      "gender_variations": {
        "masculine": "malparido",
        "feminine": "malparida"
      }
    },
    {
      "word": "mamerto",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "mamert0",
        "mamrt"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot in Colombia",
      "target_type": "individual",
      "regions": [
        "colombia"
      ],
      "gender_variations": null
    },
    {
      "word": "monda",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "m0nda",
        "mond@"
      ],
      "case_sensitive": false,
      "context_notes": "Dick in Colombia",
      "target_type": "general",
      "regions": [
        "colombia"
      ],
      "gender_variations": null
    },
    {
      "word": "sapo",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "s@po",
        "sap0"
      ],
      "case_sensitive": false,
      "context_notes": "Snitch in Colombia",
      "target_type": "individual",
      "regions": [
        "colombia"
      ],
      "gender_variations": {
        "masculine": "sapo",
        "feminine": "sapa"
      }
    },
    {
      "word": "conchatumadre",
      "severity": 4,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "conchatumdr",
        "conch@tumadre"
      ],
      "case_sensitive": false,
      "context_notes": "Motherfucker in Chile, one word",
      "target_type": "individual",
      "regions": [
        "chile"
      ],
      "gender_variations": null
    },
    {
      "word": "conchesumadre",
      "severity": 4,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "conchesumdr",
        "conch3sumadre"
      ],
      "case_sensitive": false,
      "context_notes": "Motherfucker in Chile, variant",
      "target_type": "individual",
      "regions": [
        "chile"
      ],
      "gender_variations": null
    },
    {
      "word": "chucha",
      "severity": 3,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "chuch@",
        "chuch4"
      ],
      "case_sensitive": false,
      "context_notes": "Cunt in Chile",
      "target_type": "general",
      "regions": [
        "chile"
      ],
      "gender_variations": null
    },
    {
      "word": "culear",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "cule@r",
        "culer"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck in Chile",
      "target_type": "general",
      "regions": [
        "chile"
      ],
      "gender_variations": null
    },
    {
      "word": "flaite",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "fl@ite",
        "flait3"
      ],
      "case_sensitive": false,
      "context_notes": "Lowlife in Chile",
      "target_type": "individual",
      "regions": [
        "chile"
      ],
      "gender_variations": null
    },
    {
      "word": "huevada",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "huevad@",
        "huevd"
      ],
      "case_sensitive": false,
      "context_notes": "Bullshit in Chile/Peru",
      "target_type": "general",
      "regions": [
        "chile",
        "peru"
      ],
      "gender_variations": null
    },
    {
      "word": "pelagatos",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "pelag@tos",
        "pelagats"
      ],
      "case_sensitive": false,
      "context_notes": "Nobody in Chile",
      "target_type": "individual",
      "regions": [
        "chile"
      ],
      "gender_variations": null
    },
    {
      "word": "pico",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "p1co",
        "pic0"
      ],
      "case_sensitive": false,
      "context_notes": "Dick in Chile",
      "target_type": "general",
      "regions": [
        "chile"
      ],
      "gender_variations": null
    },
    {
      "word": "sapo culiado",
      "severity": 3,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "sapo culiad0",
        "sap0 culiado"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking snitch in Chile",
      "target_type": "individual",
      "regions": [
        "chile"
      ],
      "gender_variations": null
    },
    {
      "word": "weon",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "we0n",
        "wn"
      ],
      "case_sensitive": false,
      "context_notes": "Dude, idiot in Chile, variant spelling",
      "target_type": "individual",
      "regions": [
        "chile"
      ],
      "gender_variations": {
        "masculine": "weon",
        "feminine": "weona"
      }
    },
    {
      "word": "weá",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "wea",
        "w3a"
      ],
      "case_sensitive": false,
      "context_notes": "Shit, thing in Chile",
      "target_type": "general",
      "regions": [
        "chile"
      ],
      "gender_variations": null
    },
    {
      "word": "bichote",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "bichot3",
        "bichot@"
      ],
      "case_sensitive": false,
      "context_notes": "Big shot, dealer in Puerto Rico",
      "target_type": "individual",
      "regions": [
        "puerto_rico"
      ],
      "gender_variations": null
    },
    {
      "word": "canto e'",
      "severity": 2,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "canto e",
        "cant0 e'"
      ],
      "case_sensitive": false,
      "context_notes": "Piece of, Dominican",
      "target_type": "general",
      "regions": [
        "dominican_republic"
      ],
      "gender_variations": null
    },
    {
      "word": "coño madre",
      "severity": 3,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "coño mdr",
        "coñ0 madre"
      ],
      "case_sensitive": false,
      "context_notes": "Motherfucker in Caribbean",
      "target_type": "individual",
      "regions": [
        "caribbean"
      ],
      "gender_variations": null
    },
    {
      "word": "jodón",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "jod0n",
        "jodn"
      ],
      "case_sensitive": false,
      "context_notes": "Pain in the ass",
      "target_type": "individual",
      "regions": [
        "caribbean"
      ],
      "gender_variations": {
        "masculine": "jodón",
        "feminine": "jodona"
      }
    },
    {
      "word": "maldito",
      "severity": 2,
      "categories": [
        "general",
        "religious"
      ],
      "variations": [
        "maldit0",
        "maldito"
      ],
      "case_sensitive": false,
      "context_notes": "Damned, cursed",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "maldito",
        "feminine": "maldita"
      }
    },
    {
      "word": "mamao",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "mam@o",
        "mama0"
      ],
      "case_sensitive": false,
      "context_notes": "Drunk, idiot in Dominican Republic",
      "target_type": "individual",
      "regions": [
        "dominican_republic"
      ],
      "gender_variations": null
    },
    {
      "word": "pingao",
      "severity": 2,
      "categories": [
        "sexual"
      ],
      "variations": [
        "ping@o",
        "pinga0"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking, intensifier in Cuba",
      "target_type": "general",
      "regions": [
        "cuba"
      ],
      "gender_variations": null
    },
    {
      "word": "singao",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [
        "sing@o",
        "singa0"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked in Puerto Rico",
      "target_type": "general",
      "regions": [
        "puerto_rico"
      ],
      "gender_variations": null
    },
    {
      "word": "tíguere",
      "severity": 1,
      "categories": [
        "general"
      ],
      "variations": [
        "tiguere",
        "tiguer3"
      ],
      "case_sensitive": false,
      "context_notes": "Hustler, player in Dominican Republic",
      "target_type": "individual",
      "regions": [
        "dominican_republic"
      ],
      "gender_variations": null
    },
    {
      "word": "cachudo",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "cachud0",
        "cachud@"
      ],
      "case_sensitive": false,
      "context_notes": "Cuckold in various regions",
      "target_type": "individual",
      "regions": [
        "latin_america"
      ],
      "gender_variations": null
    },
    {
      "word": "cagón",
      "severity": 1,
      "categories": [
        "scatological",
        "slurs"
      ],
      "variations": [
        "cag0n",
        "cagn"
      ],
      "case_sensitive": false,
      "context_notes": "Coward, shitter",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "cagón",
        "feminine": "cagona"
      }
    },
    {
      "word": "carapijo",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "carapij0",
        "carapij@"
      ],
      "case_sensitive": false,
      "context_notes": "Dickhead in Ecuador",
      "target_type": "individual",
      "regions": [
        "ecuador"
      ],
      "gender_variations": null
    },
    {
      "word": "cholo",
      "severity": 3,
      "categories": [
        "ethnic",
        "slurs"
      ],
      "variations": [
        "chol0",
        "ch0lo"
      ],
      "case_sensitive": false,
      "context_notes": "Ethnic/class slur in Peru/Bolivia",
      "target_type": "individual",
      "regions": [
        "peru",
        "bolivia"
      ],
      "gender_variations": {
        "masculine": "cholo",
        "feminine": "chola"
      }
    },
    {
      "word": "ñanga",
      "severity": 2,
      "categories": [
        "sexual",
        "body_parts"
      ],
      "variations": [
        "ñang@",
        "nanga"
      ],
      "case_sensitive": false,
      "context_notes": "Dick in Ecuador",
      "target_type": "general",
      "regions": [
        "ecuador"
      ],
      "gender_variations": null
    },
    {
      "word": "ñoño",
      "severity": 1,
      "categories": [
        "general",
        "slurs"
      ],
      "variations": [
        "ñoñ0",
        "nono"
      ],
      "case_sensitive": false,
      "context_notes": "Prissy, nerd, can be insulting",
      "target_type": "individual",
      "regions": [
        "all"
      ],
      "gender_variations": {
        "masculine": "ñoño",
        "feminine": "ñoña"
      }
    },
    {
      "word": "vergatario",
      "severity": 2,
      "categories": [
        "sexual",
        "slurs"
      ],
      "variations": [
        "vergat@rio",
        "vergatari0"
      ],
      "case_sensitive": false,
      "context_notes": "Dick owner, asshole in Central America",
      "target_type": "individual",
      "regions": [
        "central_america"
      ],
      "gender_variations": null
    }
  ]
} as const

export type ESType = typeof ES
